module.exports = __webpack_public_path__ + "assets/correct-answer.34b88061.svg";